(function () {
  var PRICING_BUTTON = '.inveterate__pricing button';
  var IN_CART_LABEL = /in cart/i;
  var FALLBACK_LABEL = 'Join now';
  var COUNT_TARGET = '[data-cart-count]';

  function membershipVariantIds() {
    var products = (window.inveterate && window.inveterate.membershipProducts) || [];

    return products.map(function (product) {
      return String(product.variantId);
    });
  }

  function joinLabel() {
    var landing = (window.inveterate && window.inveterate.landing) || {};
    var segments = (landing.cta && landing.cta.segments) || {};

    var label = Object.keys(segments)
      .map(function (key) {
        return segments[key].button;
      })
      .filter(Boolean)[0];

    return label || FALLBACK_LABEL;
  }

  function restoreButtons() {
    var label = joinLabel();

    document.querySelectorAll(PRICING_BUTTON).forEach(function (button) {
      if (!button.disabled || !IN_CART_LABEL.test(button.textContent)) return;

      button.disabled = false;
      button.textContent = label;
    });
  }

  function syncMembershipButton(cart) {
    var variantIds = membershipVariantIds();
    if (!variantIds.length) return;

    var inCart = (cart.items || []).some(function (item) {
      return variantIds.indexOf(String(item.variant_id)) !== -1;
    });

    if (!inCart) restoreButtons();
  }

  // Mirrors the bundle rule in sections/header.liquid: child lines of a bundle
  // are not counted, so the badge matches what a page reload would render.
  function badgeCount(cart) {
    return (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      var isBundleChild = properties._bundle_id && String(properties._bundle_parent) !== 'true';

      return isBundleChild ? total : total + item.quantity;
    }, 0);
  }

  function syncCartCount(cart) {
    var count = String(badgeCount(cart));

    document.querySelectorAll(COUNT_TARGET).forEach(function (target) {
      if (target.textContent.trim() !== count) target.textContent = count;
    });
  }

  function resync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        syncCartCount(cart);
        syncMembershipButton(cart);
      })
      .catch(function () {
      });
  }

  var pending;

  function scheduleResync() {
    clearTimeout(pending);
    pending = setTimeout(resync, 300);
  }

  window.addEventListener('aftersell:cart:cart-updated', scheduleResync);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleResync();
  });
})();
